import { render, staticRenderFns } from "./BuildingDetailsPage.vue?vue&type=template&id=1304d16e&scoped=true"
import script from "./BuildingDetailsPage.vue?vue&type=script&lang=js"
export * from "./BuildingDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./BuildingDetailsPage.vue?vue&type=style&index=0&id=1304d16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304d16e",
  null
  
)

export default component.exports